import './style.scss';
import {
  CrossIcon,
  useToastContext,
} from '@trufla-technology/trumarket-react-design-system';
import { ListUsers } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { useUnassignUsersFromTeams } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { useParams, Link } from 'react-router-dom';
import { nameInitials } from 'app/utils';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';
interface IParamTypes {
  teamKey: string;
}

export const UserCard = ({
  data,
  getUsers,
}: {
  data: ListUsers[number];
  getUsers: () => void;
}) => {
  const { isPermitted } = useAuthContext();
  const UnassignUsersFromTeams = useUnassignUsersFromTeams();
  const { teamKey } = useParams<IParamTypes>();
  const toaster = useToastContext();
  const { key, fullName, email } = data;

  const handleUnassgin = () => {
    if (!key) return;
    UnassignUsersFromTeams({
      unassigning: [{ teamKey: teamKey, userKey: key }],
    })
      .then(() => {
        getUsers();
        toaster.success('Successfully unassigned user');
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.error.replaceAll('body.', '');
        toaster.error(errorMessage || 'Failed to add a team');
      });
  };

  return (
    <div className="user-card-warper">
      <div className="user-card">
        <div className="user-icon">{nameInitials(fullName)}</div>
        <Link to={`/users/${key}`} className="user-info">
          <h2 className="user-name">{fullName}</h2>
          <p className="user-email">{email}</p>
        </Link>
        {isPermitted('unassignUsersFromTeams') && (
          <div className="user-delete-icon">
            <button type="button" className="icon" onClick={handleUnassgin}>
              <CrossIcon width="15px" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
